module.exports = __webpack_public_path__ + "static/img/serviceP1.48f2854d.png";